// Pas foto sementara untuk kartu: ilustrasi datar, bukan wajah hasil AI. Otomatis tertimpa saat foto asli diunggah.
const KULIT = ["#F1C6A5", "#E3B08D", "#D19A70", "#BC8055"];
const RAMBUT = ["#1F2937", "#3B2A20", "#111827", "#4B3A2E"];

const SERAGAM = {
  siswa: { atasan: "#1E56C8", kerah: "#FFFFFF", bawahan: "#0B3D91" },
  guru: { atasan: "#0F766E", kerah: "#F8FAFC", bawahan: "#134E4A" },
  wali_kelas: { atasan: "#0F766E", kerah: "#F8FAFC", bawahan: "#134E4A" },
  operator: { atasan: "#B45309", kerah: "#FEF3C7", bawahan: "#78350F" },
  pegawai_non_asn: { atasan: "#6D28D9", kerah: "#F5F3FF", bawahan: "#4C1D95" },
  kepala_sekolah: { atasan: "#1F2937", kerah: "#FFFFFF", bawahan: "#0B1120" },
  petugas_presensi: { atasan: "#0B3D91", kerah: "#DBEAFE", bawahan: "#082A66" },
  school_admin: { atasan: "#0B3D91", kerah: "#DBEAFE", bawahan: "#082A66" },
  orang_tua: { atasan: "#475569", kerah: "#F1F5F9", bawahan: "#1E293B" },
};

const hash = (teks) => [...String(teks || "sist")].reduce((a, c) => (a * 31 + c.charCodeAt(0)) >>> 0, 7);

export const FotoAnggota = ({ nama, gender, peran, photo, className, testId = "foto-anggota" }) => {
  if (photo) {
    return <img src={photo} alt={`Pas foto ${nama || "anggota"}`} className={className} data-testid={testId} />;
  }
  const h = hash(`${nama}|${peran}`);
  const kulit = KULIT[h % KULIT.length];
  const rambut = RAMBUT[(h >> 3) % RAMBUT.length];
  const seragam = SERAGAM[peran] || SERAGAM.orang_tua;
  const perempuan = /perempuan|pu|ni|rah|wati|yani|sari|inti|ah$/i.test(String(gender || nama || ""));
  const berhijab = gender === "Perempuan" || (gender !== "Laki-laki" && perempuan);
  const kacamata = (h >> 7) % 4 === 0;
  const kerudung = peran === "kepala_sekolah" ? "#F1F5F9" : seragam.kerah;

  return (
    <svg viewBox="0 0 120 150" role="img" aria-label={`Ilustrasi pas foto ${nama || "anggota"}`}
      className={className} data-testid={testId}>
      <defs>
        <linearGradient id={`bg-${h}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#EAF1FF" />
          <stop offset="100%" stopColor="#D7E3FA" />
        </linearGradient>
        <clipPath id={`kep-${h}`}><circle cx="60" cy="58" r="27" /></clipPath>
      </defs>
      <rect width="120" height="150" fill={`url(#bg-${h})`} />
      <circle cx="60" cy="150" r="46" fill={seragam.atasan} />
      <path d="M60 104 L44 118 L60 132 L76 118 Z" fill={seragam.kerah} />
      <rect x="52" y="80" width="16" height="20" rx="7" fill={kulit} />
      {berhijab ? (
        <path d="M60 24 C40 24 30 40 30 58 C30 78 34 92 26 108 L94 108 C86 92 90 78 90 58 C90 40 80 24 60 24 Z"
          fill={kerudung} stroke="#0B3D911a" strokeWidth="1" />
      ) : (
        <path d="M60 26 C42 26 33 40 34 56 L40 56 C40 44 48 38 60 38 C72 38 80 44 80 56 L86 56 C87 40 78 26 60 26 Z"
          fill={rambut} />
      )}
      <ellipse cx="60" cy="59" rx="22" ry="25" fill={kulit} />
      {berhijab && (
        <path d="M60 24 C40 24 30 40 30 58 C30 66 31 73 33 80 C36 60 46 50 60 50 C74 50 84 60 87 80 C89 73 90 66 90 58 C90 40 80 24 60 24 Z"
          fill={kerudung} />
      )}
      {!berhijab && <path d="M38 52 C42 40 52 34 60 34 C70 34 80 41 82 52 C74 46 66 44 60 44 C52 44 44 47 38 52 Z" fill={rambut} />}
      <g fill="#1F2937">
        <ellipse cx="51" cy="59" rx="2.1" ry="2.6" />
        <ellipse cx="69" cy="59" rx="2.1" ry="2.6" />
      </g>
      <path d="M46 52 Q51 49.5 56 52 M64 52 Q69 49.5 74 52" stroke="#1F2937" strokeWidth="1.4" fill="none" strokeLinecap="round" />
      <path d="M60 62 L58 70 Q60 71.5 62 70 Z" fill="#00000018" />
      <path d="M53 76 Q60 81 67 76" stroke="#8C4A3A" strokeWidth="2" fill="none" strokeLinecap="round" />
      {kacamata && (
        <g stroke="#0F172A" strokeWidth="1.4" fill="none" opacity=".8">
          <rect x="43" y="53" width="15" height="12" rx="5" />
          <rect x="62" y="53" width="15" height="12" rx="5" />
          <path d="M58 58 h4 M43 58 h-4 M77 58 h4" />
        </g>
      )}
      {peran === "kepala_sekolah" && !berhijab && (
        <path d="M36 40 Q60 22 84 40 L84 34 Q60 16 36 34 Z" fill="#0B1120" />
      )}
      <path d="M30 150 Q30 118 60 112 Q90 118 90 150 Z" fill={seragam.bawahan} opacity=".18" />
    </svg>
  );
};

export default FotoAnggota;
